/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetStock200ResponseAllOfData } from './GetStock200ResponseAllOfData';
import {
    GetStock200ResponseAllOfDataFromJSON,
    GetStock200ResponseAllOfDataFromJSONTyped,
    GetStock200ResponseAllOfDataToJSON,
} from './GetStock200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetStock200Response
 */
export interface GetStock200Response {
    /**
     * 
     * @type {GetStock200ResponseAllOfData}
     * @memberof GetStock200Response
     */
    data: GetStock200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetStock200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetStock200Response interface.
 */
export function instanceOfGetStock200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetStock200ResponseFromJSON(json: any): GetStock200Response {
    return GetStock200ResponseFromJSONTyped(json, false);
}

export function GetStock200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStock200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetStock200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetStock200ResponseToJSON(value?: GetStock200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetStock200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

